import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import Locale from '/@/modules/user/Enum/Locale';

// this contains original_path but that should not be returned to client-side
export class DocumentWillMeta extends BaseEntityModel {
  /**
   * @var {number}
   */
  parentId;

  /**
   * @var {string}
   */
  originalPath;

  /**
   * @var {string}
   */
  locale;

  constructor(model = {}) {
    super(model);

    this.parentId = model.parentId;
    this.originalPath = model.originalPath;
    this.locale = model.locale;
  }

  /**
   * @returns {boolean}
   */
  get isLocaleEnglish() {
    return this.locale === Locale.ENGLISH.key;
  }

  /**
   * @returns {boolean}
   */
  get isLocaleFrench() {
    return this.locale === Locale.FRENCH.key;
  }
}
